/**
 * @flow
 * @relayHash 10fb0b14a972b0dfa2baaf429331e4d1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PrePostMutationInput = {|
  formName: string,
  responses: $ReadOnlyArray<?Response>,
  clientMutationId?: ?string,
|};
export type Response = {|
  question: string,
  answer: string,
|};
export type PAWSurveyBullyingModuleMutationVariables = {|
  input: PrePostMutationInput
|};
export type PAWSurveyBullyingModuleMutationResponse = {|
  +prepostMutation: ?{|
    +nextForm: ?string
  |}
|};
export type PAWSurveyBullyingModuleMutation = {|
  variables: PAWSurveyBullyingModuleMutationVariables,
  response: PAWSurveyBullyingModuleMutationResponse,
|};
*/


/*
mutation PAWSurveyBullyingModuleMutation(
  $input: PrePostMutationInput!
) {
  prepostMutation(input: $input) {
    nextForm
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PrePostMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "prepostMutation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PrePostMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "nextForm",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PAWSurveyBullyingModuleMutation",
    "type": "RelayMutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PAWSurveyBullyingModuleMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "PAWSurveyBullyingModuleMutation",
    "id": null,
    "text": "mutation PAWSurveyBullyingModuleMutation(\n  $input: PrePostMutationInput!\n) {\n  prepostMutation(input: $input) {\n    nextForm\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '91b499cc10a371ba3942389f0a3e9555';
module.exports = node;
